'use client'
import { useGetCounties } from '@repo/services'
import { useGetDistricts } from '@repo/services/'
import { MessagesKeys, useTranslate } from '@repo/shared/hooks'
import {
  CITY_DEFAULT,
  CityType,
  FiltersState,
  NEIGHBORHOOD_DEFAULT,
  OrderByType,
  SORT_OPTIONS,
  // USAGE_OPTIONS,
  UsageType,
} from '@repo/shared/store'
import { Icon, Input } from '@repo/ui/components'
import { Row } from '@repo/ui/components/row/row'
import { useIsDesktop } from '@repo/ui/hooks'
import { useEffect, useState } from 'react'
import { CityDrawer } from './city.drawer'
import { FilterItem } from './filteritem'
import { NeighborhoodDrawer } from './neighborhood.drawer'
import { PriceDrawer } from './price.drawer'
import { SortDrawer } from './sort.drawer'
import { UsageDrawer } from './usage.drawer'

export const FiltersContainer = ({
  onFiltersChange,
  filters: initialFilters,
}: {
  onFiltersChange?: (filters: FiltersState) => void
  filters: FiltersState
}) => {
  const { t } = useTranslate()
  const isDesktop = useIsDesktop()
  const [filters, setFilters] = useState<FiltersState>(initialFilters)
  useEffect(() => {
    setFilters(initialFilters)
  }, [initialFilters])

  const handleFiltersChange = (
    updater: (filters: FiltersState) => FiltersState,
  ) => {
    const newFilters = updater(filters)

    setFilters(newFilters)
    onFiltersChange?.(newFilters)
  }

  const { data: counties } = useGetCounties({
    provinceID: 123,
  })

  const _CITIES = (counties?.data?.counties || []).map((county) => ({
    value: `${county.id}`,
    label: `${county.name}`,
  }))
  const CITIES = [CITY_DEFAULT, ..._CITIES]

  const { data: districts } = useGetDistricts({
    provinceID: 123,
    countyID: +filters.city,
  })

  const _NEIGHBORHOODS = (districts?.data?.districts || []).map((district) => ({
    value: `${district.id}`,
    label: `${district.name}`,
  }))
  const NEIGHBORHOODS = [NEIGHBORHOOD_DEFAULT, ..._NEIGHBORHOODS]

  // const { data: cities } = useGetCities({
  //   provinceID: +filters.city,
  //   countyID: filters.neighborhood ? +filters.neighborhood : undefined,
  // })
  // const { data: districts } = useGetDistricts({
  //   provinceID: +filters.city,
  //   countyID: filters.neighborhood ? +filters.neighborhood : undefined,
  // })
  const [openDrawer, setOpenDrawer] = useState<
    null | 'sort' | 'usage' | 'price' | 'city' | 'neighborhood'
  >(null)

  return (
    <div className='flex flex-row pb-md md:px-md gap-md overflow-x-auto w-full justify-between'>
      <div className=' flex items-center md:w-full gap-xs'>
        {isDesktop && (
          <Input
            value={filters.search}
            onChange={(e) =>
              handleFiltersChange((f) => ({ ...f, search: e.target.value }))
            }
            placeholder={t('common_search')}
            icon={
              <Icon
                name='SearchLine'
                size='sm'
                color='fill-neutral-surface-40'
              />
            }
            endIcon={
              filters.search && (
                <Icon
                  name='XmarkCircle'
                  size='sm'
                  color='fill-neutral-surface-40'
                  onClick={() => setFilters({ ...filters, search: '' })}
                />
              )
            }
            autoComplete='off'
            inputSize='sm'
            // autoFocus
            className='w-full max-w-[240px]'
          />
        )}
        {/* <FilterItem
          items={CITIES}
          type='filter'
          label='filters_city'
          value={filters.city}
          active={filters.city !== 'all'}
          onClick={() => setOpenDrawer('city')}
          hasReset
          onReset={() =>
            handleFiltersChange((f) => ({
              ...f,
              city: 'all',
              neighborhood: undefined,
            }))
          }
        />
        {filters.neighborhood && filters.neighborhood !== 'all' && (
          <FilterItem
            items={NEIGHBORHOODS}
            type='filter'
            label='filters_neighborhood'
            value={filters.neighborhood}
            active={true}
            onClick={() => setOpenDrawer('neighborhood')}
            hasReset
            onReset={() =>
              handleFiltersChange((f) => ({ ...f, neighborhood: undefined }))
            }
          />
        )} */}

        <FilterItem
          type='filter'
          label='filters_price'
          value={
            filters.priceMin || filters.priceMax
              ? `${filters.priceMin ? t('filters_price_from' as MessagesKeys) : ''} ${filters.priceMin?.toLocaleString() || ''}  ${filters.priceMin ? t('currency_toman' as MessagesKeys) : ''} ${filters.priceMin && filters.priceMax ? '  ' : ''} ${filters.priceMax ? t('filters_price_to' as MessagesKeys) : ''} ${filters.priceMax?.toLocaleString() || ''}  ${filters.priceMax ? t('currency_toman' as MessagesKeys) : ''} `
              : ''
          }
          active={!!(filters.priceMin || filters.priceMax)}
          onClick={() => setOpenDrawer('price')}
          hasReset
          onReset={() =>
            handleFiltersChange((f) => ({
              ...f,
              priceMin: undefined,
              priceMax: undefined,
            }))
          }
        />
        {/* <FilterItem
          items={USAGE_OPTIONS}
          type='filter'
          label='filters_usage'
          value={filters.usage}
          active={filters.usage !== 'all'}
          onClick={() => setOpenDrawer('usage')}
          hasReset
          onReset={() => handleFiltersChange((f) => ({ ...f, usage: 'all' }))}
        /> */}
      </div>
      <Row className='w-fit gap-xs'>
        <FilterItem
          items={SORT_OPTIONS}
          type='sort'
          label='filters_sort'
          value={filters.orderBy}
          active={filters.orderBy !== 'newest'}
          onClick={() => setOpenDrawer('sort')}
          hasReset
          onReset={() =>
            handleFiltersChange((f) => ({ ...f, orderBy: 'newest' }))
          }
        />
      </Row>

      {openDrawer === 'sort' && (
        <SortDrawer
          open={openDrawer === 'sort'}
          value={filters.orderBy}
          onChange={(val) => {
            handleFiltersChange((f) => ({ ...f, orderBy: val as OrderByType }))
          }}
          onClose={() => setOpenDrawer(null)}
        />
      )}

      {openDrawer === 'usage' && (
        <UsageDrawer
          open={openDrawer === 'usage'}
          value={filters.usage}
          onChange={(val) => {
            handleFiltersChange((f) => ({ ...f, usage: val as UsageType }))
          }}
          onClose={() => setOpenDrawer(null)}
        />
      )}
      {openDrawer === 'price' && (
        <PriceDrawer
          open={openDrawer === 'price'}
          min={filters.priceMin}
          max={filters.priceMax}
          onChange={(min, max) => {
            handleFiltersChange((f) => ({ ...f, priceMin: min, priceMax: max }))
          }}
          onClose={() => setOpenDrawer(null)}
        />
      )}
      <CityDrawer
        items={CITIES}
        open={openDrawer === 'city'}
        value={filters.city}
        onChange={(val) => {
          handleFiltersChange((f) => ({
            ...f,
            city: val as CityType,
            neighborhood: undefined,
          }))
        }}
        onSelectNeighborhood={() => setOpenDrawer('neighborhood')}
        onClose={() => setOpenDrawer(null)}
      />
      <NeighborhoodDrawer
        items={NEIGHBORHOODS}
        cityItems={CITIES}
        open={openDrawer === 'neighborhood'}
        city={filters.city}
        value={filters.neighborhood}
        onChange={(val) => {
          handleFiltersChange((f) => ({ ...f, neighborhood: val }))
        }}
        onClose={() => setOpenDrawer(null)}
      />
    </div>
  )
}
